// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1czZc","footer":"styles_footer__2qLjS","passCodeTooltip":"styles_passCodeTooltip__e-xnO"};